import { Extension } from "@tiptap/core";

export type Alignment = "left" | "center" | "right";

type BlockAlignOptions = {
  types: string[];
};

export const BLOCK_ALIGN_TYPES = [
  "image",
  "embed",
  "paragraph",
  "heading",
  "documentTitle",
  "tableCell",
  "tableHeader",
];

export const BlockAlign = Extension.create<BlockAlignOptions>({
  name: "blockAlign",

  addOptions() {
    return {
      types: BLOCK_ALIGN_TYPES,
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          alignment: {
            default: null,
            parseHTML(element) {
              if (element.classList.contains("text-left") || element.style.textAlign === "left") {
                return "left";
              }

              if (
                element.classList.contains("text-center") ||
                element.style.textAlign === "center"
              ) {
                return "center";
              }

              if (element.classList.contains("text-right") || element.style.textAlign === "right") {
                return "right";
              }

              return null;
            },
            renderHTML({ alignment }: { alignment?: Alignment }) {
              if (alignment) {
                return {
                  class: `text-${alignment}`,
                };
              }

              return null;
            },
          },
        },
      },
    ];
  },
});
